import axios from '../../axios'

const state = {
	currentPools: null,
}

const getters = {
	currentPools(state) {
		return state.currentPools
	}
}

const mutations = {
	SET_CURRENT_POOLS(state, currentPools) {
		state.currentPools = currentPools
	}
}

const actions = {
	async getCurrentPools({ commit }) {
		try {
			let response = await axios.get('current-pools')
			return commit('SET_CURRENT_POOLS', response.data.data)
		} catch {
			return commit('SET_CURRENT_POOLS', null)
		}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}